module.exports = __webpack_public_path__ + "media/images/icons/outlined/exclamation-ed6afa8bcbacdeee404c75e311652803.svg";